import React, { useState } from "react";

const Page7 = () => {
  const steps = [
    { title: "Mudanças nas Instalações de Processo;"},
    { title: "Mudança temporária em instalações;"},
    { title: "By-pass de interlock por mais de 7 dias;"},
    { title: "Manobras operacionais (não-rotineiras) não previstas em procedimento;"},
    { title: "Operações Infrequentes;"}, 
    { title: "Instalação de mangote/mangueira não prevista em procedimento;"}, 
    { title: "Mudanças nos Produtos Químicos e Containers;"},
    { title: "Mudanças em Controles e Lógicas (DELTA-V)"} 
  ];

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="moc-page">
      {/* ESQUERDA */}
      <div className="moc-left"  style={{paddingTop: '160px'}}>        
        <p>Até aqui, falamos sobre o que é uma mudança e como ela pode ser classificada no Gerenciamento de Mudanças.  Mas como isso aparece, de fato, no dia a dia das operações? </p>
        <p>Na prática, as mudanças nem sempre são óbvias e podem surgir em atividades rotineiras ou ajustes operacionais. </p>
        <p>A seguir, exemplos de situações que podem caracterizar uma mudança.</p>
      </div>

      {/* DIREITA */}      
      <div className="moc-right"  style={{paddingTop: '160px'}}>
        {steps.map((step, index) => (
          <div
            key={index}
            className="moc-item"            
          >
            <div className="moc-number">{index + 1}</div>
            <div className="moc-title">{step.title}</div>
          </div>
        ))}
      </div>


      <style>{`

        .container{
          width: 100% !important;
        }


        /* ROOT DA PÁGINA */
        .moc-page {
          display: flex;
          height: 100%;
          overflow: hidden;
        }

        /* COLUNA ESQUERDA */
        .moc-right {
          width: 50%;
          background: #f1f5f9;
          padding: 30px;
          box-sizing: border-box;

          display: flex;
          flex-direction: column;
          gap: 10px;

          overflow-y: auto;
        }

        /* COLUNA DIREITA */
        .moc-left {
          width: 50%;
          /*background: #4592C5;*/
          background: #f1f5f9;
          color: #000000;
          padding: 40px;
          box-sizing: border-box;

          overflow-y: auto;
        }

        /* ITEM */
        .moc-item {
          display: flex;
          align-items: center;
          background: #d9e2ec;
          border-radius: 25px;
          padding: 12px 15px;
          transition: all 0.2s ease;
        }    

       

        .moc-number {
          background: #89D127;
          color: white;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10px;
          font-weight: bold;
        }

        .moc-title {
          flex: 1;
          font-size: 14px;
        }

        .moc-plus {
          font-size: 18px;
          font-weight: bold;
          color: #3b82f6;
        }

        /* TEXTO DIREITA */
        .moc-left h2 {
          margin-bottom: 20px;
        }

        .moc-left p {
          white-space: pre-line;
          line-height: 1.6;
        }

        /* MOBILE */

      `}</style>
    </div>
  );
};

export default Page7;